import { apiCall } from '@/utils/api';

type forwardRequestBody = {
  route: string;
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE';
  data?: Record<string, any>;
  signal?: AbortSignal;
};

export const forwardRequestTo = async ({
  route,
  method,
  data,
  signal,
}: forwardRequestBody) => {
  try {
    const response = await apiCall(
      `${process.env.NEXT_PUBLIC_API}/forwarder`,
      {
        method: 'POST',
      },
      {
        route: route.startsWith('/') ? route.substring(1) : route,
        method,
        data,
      } as forwardRequestBody,
      signal,
    );
    return response;
  } catch (error) {
    return { error };
  }
};
